import { useState } from 'react';
import { Tooltip, TooltipProps } from '@mui/material';

const tooltipPopperSx = {
  zIndex: 9999,
  '& .MuiTooltip-tooltip': {
    borderRadius: '4px',
    bgcolor: '#162C36',
    maxWidth: '320px',
    paddingX: '0.5rem',
    paddingY: '0.25rem',
    color: '#F6F8F9',
    fontSize: '0.875rem',
    fontWeight: 500,
    lineHeight: '1rem',
  },
};

interface PvxTooltipProps {
  title: string;
  children: React.ReactElement;
  placement?: TooltipProps['placement'];
}

const PvxTooltip = ({ title, children, placement = 'top' }: PvxTooltipProps) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <Tooltip
      title={title}
      placement={placement}
      open={isHovered}
      disableHoverListener
      disableFocusListener
      disableTouchListener
      PopperProps={{ sx: tooltipPopperSx }}
    >
      <span
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        style={{ display: 'inline-flex' }}
      >
        {children}
      </span>
    </Tooltip>
  );
};

export default PvxTooltip;
